export default __webpack_public_path__ + "static/media/avatar.7215ef7b.jpg";